// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-modalfooter_default__2d0kv"};